// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/index.css body {
  font-size: 140%;
}

h2 {
  text-align: center;
  padding: 20px 0;
}

table.dataTable th,
table.dataTable td {
  white-space: nowrap;
}

.p {
  text-align: center;
  padding-top: 140px;
  font-size: 14px;
}

ul {
  list-style: none;
}

ul .l1::before {
  content: '\\2022';
  color: #f4c94c;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

ul .l2::before {
  content: '\\2022';
  color: #58e7d7;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

ul .l3::before {
  content: '\\2022';
  color: red;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
} */

@media only screen and (max-width: 768px) {
  /* For mobile devices with a screen width of 768px or less */
  .sec-title {
    flex-direction: column; /* Stack the elements vertically */
    align-items: center; /* Center the elements horizontally */
  }
  .sec-title__tagline {
    flex-wrap: wrap; /* Allow the tagline elements to wrap to the next line */
  
  }
  .sec-title__tagline span {
    flex-basis: 100%; /* Make the left and right spans take up the full width */
  }
  .text-center h3 {
    font-size: 18px; /* Reduce the font size for mobile devices */
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Alerts/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiDG;;AAEH;EACE,4DAA4D;EAC5D;IACE,sBAAsB,EAAE,kCAAkC;IAC1D,mBAAmB,EAAE,qCAAqC;EAC5D;EACA;IACE,eAAe,EAAE,wDAAwD;;EAE3E;EACA;IACE,gBAAgB,EAAE,yDAAyD;EAC7E;EACA;IACE,eAAe,EAAE,4CAA4C;EAC/D;AACF","sourcesContent":["/* src/index.css body {\n  font-size: 140%;\n}\n\nh2 {\n  text-align: center;\n  padding: 20px 0;\n}\n\ntable.dataTable th,\ntable.dataTable td {\n  white-space: nowrap;\n}\n\n.p {\n  text-align: center;\n  padding-top: 140px;\n  font-size: 14px;\n}\n\nul {\n  list-style: none;\n}\n\nul .l1::before {\n  content: '\\2022';\n  color: #f4c94c;\n  font-weight: bold;\n  display: inline-block;\n  width: 1em;\n  margin-left: -1em;\n}\n\nul .l2::before {\n  content: '\\2022';\n  color: #58e7d7;\n  font-weight: bold;\n  display: inline-block;\n  width: 1em;\n  margin-left: -1em;\n}\n\nul .l3::before {\n  content: '\\2022';\n  color: red;\n  font-weight: bold;\n  display: inline-block;\n  width: 1em;\n  margin-left: -1em;\n} */\n\n@media only screen and (max-width: 768px) {\n  /* For mobile devices with a screen width of 768px or less */\n  .sec-title {\n    flex-direction: column; /* Stack the elements vertically */\n    align-items: center; /* Center the elements horizontally */\n  }\n  .sec-title__tagline {\n    flex-wrap: wrap; /* Allow the tagline elements to wrap to the next line */\n  \n  }\n  .sec-title__tagline span {\n    flex-basis: 100%; /* Make the left and right spans take up the full width */\n  }\n  .text-center h3 {\n    font-size: 18px; /* Reduce the font size for mobile devices */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
